import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../InfinitePages/Dashboard/Header";
import StylishLoadingDialog from "../../InfinitePages/Dashboard/InfiniteLoader";
import axios from "axios";
import { tokens } from "../../theme";

export default function ShraddhaEvents() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem("token");
  const [EventList, setEventList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch the event list data
  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/display/eventList",
        {},
        {
          headers: { Authorization: token },
        }
      );
      const sortedEvents = response.data.rows;
      const revEvents = sortedEvents.reverse();
      setEventList(revEvents);
    } catch (error) {
      //console.log("Error fetching data", error);
    }
    setLoading(false); // End loading
  };

  // Handle registration action
  const handleRegistration = async (event_RegLink, eventId) => {
    window.open(event_RegLink); // Open registration link
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/display/eventclickcount",
        { eventId },
        {
          headers: { Authorization: token },
        }
      );
    } catch (error) {
      //console.log("Error tracking event click", error);
    }
  };

  // useEffect to fetch events on component mount
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box
      sx={{
        padding: {
          xs: "30px 10px 30px 0px ",
          sm: "30px 10px 30px 0px ",
          md: "30px 10px 30px 0px ",
          lg: "30px 10px 30px 0px ", // Increased height for larger screens
          xl: "30px 10px 30px 0px ", // Extra large screens
        },

        margin: {
          xs: "6vw 0vw 0vw 0vw",
          sm: "6vw 0vw 0vw 0vw",
          md: "4vw 0vw 0vw 0vw",
          lg: "4vw 0vw 0vw 0vw", // Increased height for larger screens
          xl: "4vw 0vw 0vw 0vw", // Extra large screens
        },
      }}
    >
      <Header title="Events" subtitle="Events Calendar" />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          margin: "0vw 0vw 10vw 0vw",
        }}
      >
        {EventList.map((event) => (
          <Card
            key={event.event_Id}
            sx={{
              // justifyContent: { xs: "center", sm: "center" }, // Center horizontally on all screen sizes
              // alignItems: { xs: "center", sm: "center" }, // Center vertically on all screen sizes
              width: {
                xs: "300px",
                sm: "300px",
                md: "400px",
                lg: "400px", // Increased width for larger screens
                xl: "400px", // Extra large screens
              },

              border: new Date(event.event_StartDay) > new Date() ? 4 : 0.5,
              borderColor:
                new Date(event.event_StartDay) > new Date()
                  ? "#B09246"
                  : "primary.main",
              backgroundColor: "background.paper",
              boxShadow: new Date(event.event_StartDay) > new Date() ? 20 : 12,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: 12,
              },
            }}
          >
            <CardContent>
              <Typography variant="h3" gutterBottom>
                {event.event_Name}
              </Typography>
              <Typography
                variant="h5"
                gutterBottom
                dangerouslySetInnerHTML={{ __html: event.event_Agenda }}
              />
              <Typography variant="body1">
                <strong>Date:</strong> {event.event_StartDay}
              </Typography>
              <Typography variant="body1">
                <strong>Time:</strong> {event.event_StartTime} -{" "}
                {event.event_EndTime}
              </Typography>
              <Typography variant="body2">
                <strong>Location:</strong> {event.event_Location}
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "10px",
                  mb: "10px",
                  ml: "10px",
                  backgroundColor: "#B09246",
                  ":hover": { backgroundColor: "#a0813f" },
                }}
                onClick={() =>
                  handleRegistration(event.event_RegLink, event.event_Id)
                }
              >
                Join Now
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
      <StylishLoadingDialog loading={loading} />
    </Box>
  );
}
